export const utcDay = (value = new Date()) => value.toISOString().slice(0, 10);

export function shiftUtcDay(day: string, offset: number) {
  const value = new Date(`${day}T12:00:00.000Z`);
  value.setUTCDate(value.getUTCDate() + offset);
  return utcDay(value);
}

export function recentProDayWindow(now = new Date()) {
  const today = utcDay(now);
  return { oldestDay: shiftUtcDay(today, -28), latestDay: shiftUtcDay(today, -1) };
}

export function initialRecentProDay(matchDate?: string, now = new Date()) {
  const { oldestDay, latestDay } = recentProDayWindow(now);
  const day = matchDate?.slice(0, 10) || latestDay;
  return day > latestDay ? latestDay : day < oldestDay ? oldestDay : day;
}

/** Initial sidebar selection skips empty days; explicit arrow navigation remains unchanged. */
export async function latestRecentProResults<T extends { items: { demos: unknown[] }[] }>(
  loadDay: (day: string) => Promise<T>, signal: AbortSignal, now = new Date(),
): Promise<{ date: string; data: T }> {
  const { oldestDay, latestDay } = recentProDayWindow(now);
  let first: T | undefined;
  for (let day = latestDay; day >= oldestDay; day = shiftUtcDay(day, -1)) {
    signal.throwIfAborted();
    const data = await loadDay(day);
    signal.throwIfAborted();
    first ??= data;
    if (data.items.some(match => match.demos.length > 0)) return { date: day, data };
  }
  return { date: latestDay, data: first! };
}
